module.exports = __webpack_public_path__ + "static/media/sura-off-app-provider-icon.0bf88546.svg";